"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("../classnames"));
var useAutoFocus_1 = __importDefault(require("../utils/useAutoFocus"));
var Checkmark = function (_a) {
    var autoFocus = _a.autoFocus, children = _a.children, className = _a.className, checked = _a.checked, onClick = _a.onClick, label = _a.label, props = __rest(_a, ["autoFocus", "children", "className", "checked", "onClick", "label"]);
    var buttonRef = react_1.useRef(null);
    var onButtonClick = onClick ? function () { return onClick(!checked); } : undefined;
    useAutoFocus_1.default(autoFocus, buttonRef);
    if (label) {
        return (react_1.default.createElement("span", __assign({ ref: buttonRef }, props, { className: classnames_1.default("chq-cmk", className, {
                "chq-cmk-ck": checked || false,
                "chq-cmk-cl": !!onClick
            }), "aria-label": label + " is " + (checked ? "" : "not ") + "fulfilled" }),
            react_1.default.createElement("svg", { viewBox: "0 0 52 52" },
                react_1.default.createElement("circle", { cx: "26", cy: "26", r: "25", fill: "none" }),
                react_1.default.createElement("path", { fill: "none", d: "M14.1 27.2l7.1 7.2 16.7-16.8" })),
            label));
    }
    return (react_1.default.createElement("button", __assign({ ref: buttonRef }, props, { type: "button", className: classnames_1.default("chq-cmk", className, {
            "chq-cmk-ck": checked || false,
            "chq-cmk-cl": !!onClick
        }), onClick: onButtonClick, "aria-label": children ? undefined : "Checkmark" }),
        react_1.default.createElement("svg", { viewBox: "0 0 52 52" },
            react_1.default.createElement("circle", { cx: "26", cy: "26", r: "25", fill: "none" }),
            react_1.default.createElement("path", { fill: "none", d: "M14.1 27.2l7.1 7.2 16.7-16.8" })),
        children && react_1.default.createElement(react_1.default.Fragment, null,
            " ",
            children)));
};
exports.default = Checkmark;
